import { c as _c } from "react/compiler-runtime";
import type { CreditCardOffer } from '@cc-shopping/contracts/cross-site/marketplace/types';
import { ApplyNowButton } from 'src/features/product-card/ApplyNowButton';
import { getAnalyticsProps } from '../analyticsUtils';
export const LearnMore = t0 => {
  const $ = _c(17);
  const {
    creditCardOffer,
    rowIndex
  } = t0;
  let t1;
  if ($[0] !== creditCardOffer || $[1] !== rowIndex) {
    t1 = getAnalyticsProps(creditCardOffer, rowIndex);
    $[0] = creditCardOffer;
    $[1] = rowIndex;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const analytics = t1;
  const {
    details: t2,
    institution: t3,
    name
  } = creditCardOffer;
  const {
    applyLink,
    applyPhoneNumber,
    isActive,
    isMonetizing,
    reviewLink,
    termsFeesLink
  } = t2;
  const {
    name: institutionName
  } = t3;
  const t4 = `learn-more-apply-now-${creditCardOffer.id}`;
  let t5;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      width: "150px"
    };
    t6 = {
      lineHeight: 1.43
    };
    $[3] = t5;
    $[4] = t6;
  } else {
    t5 = $[3];
    t6 = $[4];
  }
  let t7;
  if ($[5] !== analytics || $[6] !== applyLink || $[7] !== applyPhoneNumber || $[8] !== creditCardOffer.details.versionId || $[9] !== institutionName || $[10] !== isActive || $[11] !== isMonetizing || $[12] !== name || $[13] !== reviewLink || $[14] !== t4 || $[15] !== termsFeesLink) {
    t7 = <ApplyNowButton id={t4} isActive={isActive} isMonetizing={isMonetizing} applyLink={applyLink} termsFeesRedirectLink={termsFeesLink} reviewLink={reviewLink} applyPhoneNumber={applyPhoneNumber} institutionName={institutionName} analytics={analytics} versionId={creditCardOffer.details.versionId} name={name} sx={t5} linkSx={t6} />;
    $[5] = analytics;
    $[6] = applyLink;
    $[7] = applyPhoneNumber;
    $[8] = creditCardOffer.details.versionId;
    $[9] = institutionName;
    $[10] = isActive;
    $[11] = isMonetizing;
    $[12] = name;
    $[13] = reviewLink;
    $[14] = t4;
    $[15] = termsFeesLink;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};